import React from 'react';
import { useRouter } from '../../../hooks';

function VerificationSuccessPage() {
    const router = useRouter();
    return (
        <div className='success-page' style={{ textAlign: 'center', padding: '50px' }}>
            <h2>Cuenta registrada satisfactoriamente! Ya puedes iniciar sesión!</h2>
            
            <br /><br/><br /><br/>

            <button type='submit' className='btn btn-primary' onClick={() => {router.push('auth/login')}}>
                Iniciar sesión
            </button>
            <br /><br/><br/><br /><br/><br/><br /><br/><br/>
        </div>
    );
}

export default VerificationSuccessPage;